export interface PosConfig {
  allowDiscount: boolean;
  allowInventoryView: boolean;
  allowOrderCancel: boolean;
  allowStaffVoid: boolean;
  managerPin: string;
  posTheme: string;
  locationId?: string | null;
}

export const DEFAULT_POS_CONFIG: PosConfig = {
  allowDiscount: false,
  allowInventoryView: false,
  allowOrderCancel: false,
  allowStaffVoid: false,
  managerPin: '',
  posTheme: 'dark',
};
